export default __webpack_public_path__ + "static/media/1.686c7d0b.jpg";